import { IChartModels } from "./chart.models";

/**
 * Maps the chart ids to the corresponding chart type.
 */
export const chartIds: IChartModels = {
	clientAccumulated: "clientAccumulated-chart",
	productCount: "productCount-chart",
	productSales: "productSales-chart",
	productWeeklySales: "productWeeklySales-chart",
	clientOrders: "clientOrders-chart",
	clientCount: "clientCount-chart",
	ordersAccumulated: "ordersAccumulated-chart",
	ordersByStatus: "ordersByStatus-chart",
	ordersByStatusWeekly: "ordersByStatusWeekly-chart"
};
